module.exports = __webpack_public_path__ + "static/media/icon-menu.c4597a11.svg";